export default function validation(response, messages) {
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }

  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('CONTACT_DELETE_FORBIDDEN_IS_LINKED_TO_BILL') === 0) {
      const information = message.split('|')[0].split('@')[1];
      messages.push({
        message: 'supprimerContact.messages.deleteFailed',
        parametres: { nomPrenom: information },
      });
    }
    if (message.indexOf('CONTACT_CANNOT_DELETED_BECAUSED_IT_IS_LINKED_USER') === 0) {
      const information = message.split('|')[0].split('@')[1];
      messages.push({
        message: 'supprimerContact.messages.deleteContactUtilisateur',
        parametres: { nomPrenom: information },
      });
    }
  });
}
